import { fetchContactInfoService } from "./fetchContactInfo";
import { finalizePackageService } from "./finalizePackage";

export const checkoutServices = {
  fetchContactInfoService,
  finalizePackageService,
};
